export default __webpack_public_path__ + "static/media/gtd3.c3ce31c2.jpg";